import { resizeUsingSpacingElementSrc38Evid1607 } from '@wix/bi-logger-editor-data/v2';
import { biLogger } from '#packages/util';

import type { EditorAPI } from '#packages/editorAPI';
import type { Gap } from './resizeGapsTypes';

interface ReportGapResizedBIParams {
  initialGap: Gap;
  updatedGap: Gap;
  isSnapped: boolean;
}

export const reportGapResizedBI = (
  editorAPI: EditorAPI,
  { initialGap, updatedGap, isSnapped }: ReportGapResizedBIParams,
) => {
  const nonPageAncestors = [
    initialGap.container,
    ...editorAPI.components
      .getAncestors(initialGap.container)
      .filter((comp) => !editorAPI.components.is.page(comp)),
  ];

  biLogger.report(
    //@ts-expect-error
    resizeUsingSpacingElementSrc38Evid1607({
      resize_value_origin: Math.round(initialGap.layout.height),
      resize_value: Math.round(updatedGap.layout.height),
      equal_spacing_stop_resize: isSnapped,

      parent_component_type: editorAPI.components.getType(nonPageAncestors[0]),
      parent_component_id: nonPageAncestors[0].id,
      non_page_top_parent_component_type: editorAPI.components.getType(
        nonPageAncestors[nonPageAncestors.length - 1],
      ),
      non_page_top_parent_component_id:
        nonPageAncestors[nonPageAncestors.length - 1].id,
      editor_working_mode: editorAPI.isMobileEditor() ? 'mobile' : 'desktop',
    }),
  );
};
